const state = {
    simulation: {
        'totalDays': '',
        'stay': '',
        'commission': '',
        'total': '',
        // House & Flats cobra el primer mes y le descuenta la comisión del 4%
        // al anfitrión; el resto de los meses van directo al anfitrión.
        'stayTotal': '',
        'commissionRate': 4,
        'grandTotal': '',
        'months': 0,
        'monthlyRent': '',
        'firstMonth': '',
        'remainingToHost': '',
    },
    accommodationId: '',
    initDate: '',
    endDate: '',
    guests: 1,
    available: false
};

export default state;